import styled, { css } from 'styled-components';

import { defaultThemeProp } from '@pega/cosmos-react-core/lib/theme';

export const ResizeableEl = styled.div(({ theme }) => {
  return css`
    position: relative;
    display: inline-block;
    resize: horizontal;
    width: 26ch;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;

    &::after {
      content: '';
      display: block;
      position: absolute;
      inset: 0;
      border: 0.0625rem dashed ${theme.base.palette['border-line']};
    }
  `;
});

ResizeableEl.defaultProps = defaultThemeProp;
